/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelJournalDriver.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/journal-driver";

export class AutogenModelJournalDriver<RowType extends ModelRow> extends Endpoint<RowType, RowJournalDriverFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowJournalDriver extends ModelRow<RowJournalDriverFields> {
	constructor(values?: Partial<RowJournalDriverFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowJournalDriverFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	batch_code: string;
	batch_number: number;
	batch_seq: number;
	check_no: string;
	company_from: string;
	company_id: string;
	correction: string;
	descr: string;
	glid: string;
	gp_exported: Date;
	id: string;
	is_intercompany: string;
	memo: string;
	order_id: string;
	payee_id: string;
	post_date: Date;
	post_key: string;
	post_module: string;
	transaction_date: Date;
}

